import { css } from 'aphrodite';
import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { AdherencePanel } from './AdherencePanel';
import { ConversationInsights } from './ConversationInsights';
import { ConversationList } from './ConversationList';
import { MetadataPanel } from './MetadataPanel';
import { styleSheet } from './styles';
import { TranscriptPanel } from './TranscriptPanel';

/**
 * Admin-gated Coffee page for reviewing an account's SalesLiveCoaching AI conversations. The left
 * panel lists the account's coaching conversations (across all reps) and tracks the selected one;
 * selecting a conversation populates the metadata, transcript, insights, and adherence panels on
 * the right.
 *
 * Access: the `/ai-coaching-review` route is gated on `userSession.account.isAdmin` (see
 * `AidaRouter`), so it is available to admins/managers of the current account — not restricted to
 * Levitate-internal accounts. The page is account-scoped: it only ever surfaces the viewing
 * account's own conversations.
 */
export function CoffeeAICoachingReview() {
	const [selectedConversationId, setSelectedConversationId] = React.useState<string | null>(null);
	const isMobile = useMediaQuery({ maxWidth: THEME.breakpoints.md });

	const showList = !isMobile || !selectedConversationId;
	const showDetail = !isMobile || Boolean(selectedConversationId);

	return (
		<div className={css(styleSheet.layout)}>
			{showList ? (
				<section className={css(styleSheet.panel, styleSheet.listPanel)}>
					<div className={css(styleSheet.panelHeader)}>
						<h2 className={css(styleSheet.panelTitle)}>AI Coaching Conversations</h2>
					</div>
					<ConversationList selectedConversationId={selectedConversationId} onSelect={setSelectedConversationId} />
				</section>
			) : null}

			{showDetail ? (
				<section className={css(styleSheet.panel, styleSheet.detailPanel)}>
					<MetadataPanel conversationId={selectedConversationId} />
					<ConversationInsights conversationId={selectedConversationId} />
					<TranscriptPanel conversationId={selectedConversationId} />
					<AdherencePanel conversationId={selectedConversationId} />
				</section>
			) : null}
		</div>
	);
}
